import { createSlice } from "@reduxjs/toolkit";
import { fetchUsers, createUser } from "./usersApi";
import { IUsers } from "../../../models/users";

interface UsersState {
    users: Array<IUsers>;
    isLoading: boolean;
    error: any;
}

const initialState: UsersState = {
    users: [],
    isLoading: false,
    error: null
}

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.isLoading = false;
                state.users = action?.payload?.data || [];
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                console.log('error', action.payload)
                state.isLoading = false;
            })
            .addCase(createUser.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(createUser.rejected, (state, action) => {
                console.log('rejected', action.payload);
                state.isLoading = false;
            });
    }
});

export default usersSlice.reducer;